import { parse, stringify } from 'flatted';

const fromStorage = (storage, key) => {
  const storageItem = storage.getItem(key);
  try {
    return parse(storageItem);
  } catch (error) {
    return JSON.parse(storageItem);
  }
};

const toStorage = (storage, key, obj, isJsObj) => {
  if (!key || typeof key !== 'string') {
    throw new Error('Key must be a non-empty string');
  }
  if (!obj) {
    obj = stringify(null);
  } else if (isJsObj) {
    obj = stringify(obj);
  } else {
    obj = stringify(obj.toJs());
  }
  storage.setItem(key, obj);
};

const removeStorage = (storage, key) => {
  storage.removeItem(key);
};

export const fromLocalStorage = key => {
  return fromStorage(localStorage, key);
};

export const toLocalStorage = (key, obj, isJsObj) => {
  toStorage(localStorage, key, obj, isJsObj);
};

export const removeLocalStorage = key => {
  removeStorage(localStorage, key);
};

export const fromSessionStorage = key => {
  return fromStorage(sessionStorage, key);
};

export const toSessionStorage = (key, obj, isJsObj) => {
  toStorage(sessionStorage, key, obj, isJsObj);
};

export const removeSessionStorage = key => {
  removeStorage(sessionStorage, key);
};

export default {
  get: fromLocalStorage,
  set: toLocalStorage,
  remove: removeLocalStorage,
};
